import React from 'react';
import PropTypes from 'prop-types';
import { SocialNetworkIcon } from 'components';
import styles from './SocialNetworkIconBar.scss';

function SocialNetworkIconBar(props) {
  // Get a Set of the social networks in case an array was passed in.
  var networks = props.networks instanceof Set ? props.networks : new Set(networks);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.bar, " ").concat(props.className),
    style: props.style
  }, networks.has('facebook') && /*#__PURE__*/React.createElement(SocialNetworkIcon, {
    size: props.iconSize,
    network: "facebook"
  }), networks.has('twitter') && /*#__PURE__*/React.createElement(SocialNetworkIcon, {
    size: props.iconSize,
    network: "twitter"
  }), networks.has('linkedin') && /*#__PURE__*/React.createElement(SocialNetworkIcon, {
    size: props.iconSize,
    network: "linkedin"
  }), networks.has('instagram') && /*#__PURE__*/React.createElement(SocialNetworkIcon, {
    size: props.iconSize,
    network: "instagram"
  }), networks.has('google') && /*#__PURE__*/React.createElement(SocialNetworkIcon, {
    size: props.iconSize,
    network: "google"
  }));
}

SocialNetworkIconBar.propTypes = {
  networks: PropTypes.oneOfType([PropTypes.instanceOf(Set), PropTypes.array]).isRequired,
  iconSize: PropTypes.string
};
SocialNetworkIconBar.defaultProps = {
  style: {},
  className: ''
};
export default SocialNetworkIconBar;